import { Col, Container } from 'components/GridSystem';
import { Lock } from '@styled-icons/remix-fill/Lock';
import FormButton from 'components/Button';

import * as S from './style';
import StripeLogo from 'assets/svg/stripe-logo.svg';
import PlaidButton from 'components/PlaidButton';

export type FloatPlaidButtonType = {
  children: string | JSX.Element;
  icon?: JSX.Element;
  onClick?: () => void;
  disabled?: boolean;
  type?: 'button' | 'submit';
  minimal?: boolean;
};

const FloatPlaidButton = ({
  children,
  icon,
  onClick,
  disabled,
  type = 'button',
  minimal = false,
}: FloatPlaidButtonType) => {
  return (
    <S.Wrapper minimal={minimal}>
      <Container>
        <S.Row>
          <Col xs={12} sm={12} md={12} lg={12} xl={12}>
            <PlaidButton
              disabled={disabled}
              type={type}
              onClick={onClick}
              icon={icon}
            >
              {children}
            </PlaidButton>
          </Col>
        </S.Row>
      </Container>
    </S.Wrapper>
  );
};

export default FloatPlaidButton;
